import { toast } from "react-toastify";

const handleInstaMessenger = (bot_id, user_id, setProcess) => {
  const instaLoginCallback = async (response, bot_id, user_id) => {
    console.log("response,", response);
    if (response?.authResponse) {
      const access_token = response.authResponse.accessToken;
      console.log("access_token", access_token);

      if (access_token) {
        try {
          const uri = `${process.env.REACT_APP_SERVER}/int/handleInstaMsgFlow`;
          const options = {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ access_token, bot_id, user_id }),
          };

          const res = await fetch(uri, options);

          if (res.ok) {
            setProcess((prev) => !prev);
            toast.success("Instagram Messenger Connected Successfully");
          } else {
            toast.error("Internal server error, try again later...");
          }
        } catch (error) {
          console.error("Error during Instagram auth exchange:", error);
          toast.error("Something went wrong. Please try again.");
        }
      } else {
        console.warn("Instagram login canceled or failed", response);
        toast.error("Instagram login canceled or failed");
      }
    } else {
      console.warn("Instagram login canceled or failed", response);
      toast.error("Instagram login canceled or failed");
    }
  };

  if (!window.FB) {
    console.error("Facebook SDK not loaded");
    toast.error("Facebook SDK not loaded");
    return;
  }

  try {
    window.FB.login(
      (response) => instaLoginCallback(response, bot_id, user_id),
      {
        config_id: "674183628807217",
        response_type: "token",
        override_default_response_type: true,
        extras: {
          setup: {},
          featureType: "instagram_messaging",
          sessionInfoVersion: "2",
        },
      }
    );
  } catch (err) {
    console.error("FB login error:", err);
    toast.error("Instagram login failed due to unexpected error");
  }
};

export default handleInstaMessenger;
